export const PIXELS_TO_CM = 2.54 / 96;